(function () {
    'use strict';

    run.admin.parts.rackootControls = function() {
        // Controls visibility
        const controls = document.getElementById('rackoot__controls');
        const overlay = document.getElementById('rackoot__controls_overlay');

        document.body.addEventListener('click', function(e) {
            // let rackoot_controls = e.target.closest('#rackoot__controls_toggler');
            let rackoot_controls_toggler = e.target.closest('#rackoots_items__settings');
            if (rackoot_controls_toggler == null || rackoot_controls_toggler == 'undefined') { return; }
            rackoot_controls_toggler.classList.toggle('open');
            if (rackoot_controls_toggler) {
                controls.classList.toggle('visible');
                overlay.classList.toggle('visible');

                overlay.addEventListener('click', function(e) {
                    closeRackootSettings();
                })
            }
        });

        document.body.addEventListener('click', function(e) {
            let rackoot_controls_close = e.target.closest('#rackoot__controls_close');
            if (rackoot_controls_close == null || rackoot_controls_close == 'undefined') { return; }
            closeRackootSettings();
        });

        function closeRackootSettings()
        {
            controls.classList.remove('visible');
            overlay.classList.remove('visible');    
        }
    }
})();
